import React, { Component } from 'react'
import { Layout, Typography, Row, Col, Button, Card, Carousel, message, Icon, Tag, Tooltip, Spin, Input, Popconfirm } from 'antd';
import ReplyComment from './replycomment'
import moment from "moment"
const { TextArea } = Input;

class MainComment extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showCommentBox: false,
      liked: false,
      commentInfo: {}
    }
  }

  toggleCommentBox = () => {
    let { showCommentBox } = this.state
    this.setState({
      showCommentBox: !showCommentBox
    })
  }

  toggleLike = () => {
    let { liked } = this.state
    const { post, profile, commentInfo } = this.props
    let likers = post.likers
    this.setState({
      liked: !liked
    })
    if(!liked) {
      likers.push(profile.uid)
      let commentDetails = {
        postId: post.id,
        // commentId,
        likers,

      }
    } else {
      // dislike
    }
  }

  componentWillReceiveProps (nextProps) {
    const { commentInfo } = nextProps
    if(commentInfo) {
      this.setState({
        commentInfo
      })
    }
  }
  
  render() {
    const { showCommentBox, liked, commentInfo } = this.state
    const { profile } = this.props

    return (
      <div className="main-comment">
        <Row>
          <Col lg={2} className="comment-img">
            <img src="/img/user.png" alt="" />
          </Col>
          <Col lg={22} className="comment-details">
            <h6 className="name">{commentInfo.commenterName}</h6>
            <span>
              <Icon type="clock-circle" className="clock-icon" />
              {moment(commentInfo.created).fromNow()}
          </span>
            <span className="no-likes">
              <Icon type="like" theme="filled" /> {commentInfo.likes}
          </span>
            <p className="comment-writeup">
            {commentInfo.content}
          </p>
            <div className="actions">
              {
                liked ? <Button onClick={() => this.toggleLike()}>
                  Unlike
              <i className="far fa-thumbs-down custom-icon"></i>
                </Button> : <Button onClick={() => this.toggleLike()}>
                    Like
              <Icon type="like" theme="filled" />
                  </Button>
              }
              <Button onClick={() => this.toggleCommentBox()}>
                Reply
              <i className="fas fa-reply custom-icon"></i>
              </Button>
              {
                commentInfo.commenterId === profile.uid ? <Popconfirm
                title="Are you sure you want to delete your comment?"
                // onConfirm={}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button>
                  Delete
                  <Icon type="delete" theme="filled" />
                </Button>
              </Popconfirm> : null
              }
            </div>
            {
              showCommentBox && <div className="replycommenttext">
                <Row>
                  <Col lg={24} className="replycommenttext-box">
                    <TextArea rows={4} placeholder="Reply" />
                    <Button type="primary" className="send-btn">
                      Send
                  <i className="fas fa-paper-plane"></i>
                    </Button>
                    <Button type="danger" className="cancel-btn" onClick={() => this.toggleCommentBox()}>
                      Cancel
                    <i className="fas fa-times"></i>
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          </Col>
        </Row>
        {/* <ReplyComment /> */}
      </div>
    )
  }
}

export default MainComment
